import Layout from "layout/Layout";
import AttributionMappingTable from "./components/AttributionMappingTable";

export default function AttributionMappingsPage() {
  return (
    <Layout>
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Attribution Mappings</h1>
      <AttributionMappingTable />
    </Layout>
  );
}
